import { Image as CoreImage } from '@starsoft/common/components';
import { ValueWithCoinCellProps } from './props';
import styles from './styles.module.scss';

export default function ValueWithCoinCell({
  coin,
  value,
}: ValueWithCoinCellProps) {
  return (
    <div className={styles.container}>
      <CoreImage
        className={styles.container__image}
        width={14}
        height={14}
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${
          coin?.image ?? 'brl.svg'
        }`}
        alt={coin?.code}
      />
      {value}
    </div>
  );
}
